import { getTimeMillisApi } from '@/api/common'

const state = {
  innerWH: {}, // 浏览器窗口宽高
  // 系统时间
  systemTime: ''
}

const mutations = {
  SET_INNER_WH(state, val) {
    state.innerWH = val
  },
  SET_SYSTEM_TIME(state, time) {
    state.systemTime = time
  }
}

const actions = {
  setInnerWH({ commit }, val) {
    commit('SET_INNER_WH', val)
  },

  /**
   * 获取系统时间（不精确）
   * @param commit
   * @param axios
   * @returns {Promise<unknown>}
   */
  getSystemTime({ commit }, axios) {
    return new Promise((resolve, reject) => {
      getTimeMillisApi(axios)
        .then((res) => {
          commit('SET_SYSTEM_TIME', res.data || '')
          resolve()
        })
        .catch(() => {
          commit('SET_SYSTEM_TIME', Date.now())
          resolve()
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
